/**
 * Sélecteur d'emojis compact du portail (grille des plus utilisés).
 * Partagé par le chat entre étudiants et le chat avec le personnel (2026-10-03).
 */
import React, { useEffect, useRef } from 'react';

// ─── Emoji picker compact (8x6 grille des plus utilisés) ─────────
const EMOJIS = [
  '😀','😃','😄','😁','😆','😅','😂','🤣',
  '😊','😇','🙂','🙃','😉','😌','😍','🥰',
  '😘','😗','😙','😚','😋','😛','😜','🤪',
  '🤨','🧐','🤓','😎','🤩','🥳','😏','😒',
  '😞','😔','😟','😕','🙁','😣','😖','😫',
  '😭','😤','😠','😡','🤬','🤯','😳','🥵',
  '👍','👎','👏','🙏','💪','🙌','👌','✌️',
  '❤️','🧡','💛','💚','💙','💜','🤍','🖤',
  '🎉','🔥','✨','⭐','💯','✅','❌','❓',
];

export const EmojiPicker: React.FC<{
  onPick: (emoji: string) => void;
  onClose: () => void;
}> = ({ onPick, onClose }) => {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const onDoc = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) onClose();
    };
    setTimeout(() => document.addEventListener('mousedown', onDoc), 10);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [onClose]);
  return (
    <div
      ref={ref}
      className="absolute bottom-12 left-0 z-30 bg-gray-900 border border-gray-700 rounded-lg shadow-2xl p-2 grid grid-cols-8 gap-1 w-[280px]"
    >
      {EMOJIS.map(e => (
        <button
          key={e}
          type="button"
          onClick={() => onPick(e)}
          className="w-8 h-8 flex items-center justify-center text-lg hover:bg-gray-800 rounded transition-colors"
        >
          {e}
        </button>
      ))}
    </div>
  );
};

export default EmojiPicker;
